//公用的一些函数
/**
 * 验证手机号
 * @param {Object} mobile
 */
export function checkPhone(mobile) {
	if (mobile == '') {
		return false;
	}
	var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
	if (!myreg.test(mobile)) {
		return false;
	} else {
		return true;
	}
}
// 判断邮箱
export function chkMail(email){
   var reEml =  /^\w+@[a-z0-9]+(\.[a-z]+){1,3}$/;
	
	var isOk = reEml.test(email);

    if (isOk == false){
         // alert("请输入正确的邮箱地址!") ;
         // email.focus();
	}
    return isOk
}
/**
 * 获取用户端得token
 */
export function getToken(){
	return uni.getStorageSync('token');
}

/**
 * 设置用户token
 * @param {Object} val
 */
export function setToken(val){
	return (uni.setStorageSync('token', val)) ? true:false;
}
//俩了个数字相加
export function addNum (num1, num2) {
	var val = (num1 * 100 + num2 * 100) / 100;
	return val.toFixed(2);  
}
//数字转大写
export function changeNumMoneyToChinese(money)
{
    var cnNums = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"); //汉字的数字
    var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
    var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
    var cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位
    var cnInteger = "整"; //整数金额时后面跟的字符
    var cnIntLast = "元"; //整型完以后的单位
    var maxNum = 999999999999999.9999; //最大处理的数字
    var IntegerNum; //金额整数部分
    var DecimalNum; //金额小数部分
    var ChineseStr = ""; //输出的中文金额字符串
    var parts; //分离金额后用的数组，预定义    
    var Symbol="";//正负值标记
    if (money == "") {
        return "";
    }

    money = parseFloat(money);
    if (money >= maxNum) {
        alert('超出最大处理数字');
        return "";
    }
    if (money == 0) {
        ChineseStr = cnNums[0] + cnIntLast + cnInteger;
        return ChineseStr;
    }
    if(money<0)
    {
        money=-money;
        Symbol="负 ";        
    }
    money = money.toString(); //转换为字符串
    if (money.indexOf(".") == -1) {
        IntegerNum = money;
        DecimalNum = '';
    } else {
        parts = money.split(".");
        IntegerNum = parts[0];
        DecimalNum = parts[1].substr(0, 4);
    }
    if (parseInt(IntegerNum, 10) > 0) { //获取整型部分转换
        var zeroCount = 0;
        var IntLen = IntegerNum.length;
        for (var i = 0; i < IntLen; i++) {
            var n = IntegerNum.substr(i, 1);
            var p = IntLen - i - 1;
            var q = p / 4;
            var m = p % 4;
            if (n == "0") {
                zeroCount++;
            }
            else {
                if (zeroCount > 0) {
                    ChineseStr += cnNums[0];
                }
                zeroCount = 0; //归零
                ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
            }
            if (m == 0 && zeroCount < 4) {
                ChineseStr += cnIntUnits[q];
            }
        }
        ChineseStr += cnIntLast;
        //整型部分处理完毕
    }
    if (DecimalNum != '') { //小数部分
        var decLen = DecimalNum.length;
        for (var i = 0; i < decLen; i++) {
            var n = DecimalNum.substr(i, 1);
            if (n != '0') {
                ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
            }
        }
    }
    if (ChineseStr == '') {
        ChineseStr += cnNums[0] + cnIntLast + cnInteger;
    } else if (DecimalNum == '') {
        ChineseStr += cnInteger;
    }
    ChineseStr = Symbol +ChineseStr;
    
    return ChineseStr;
}
/**
 * @desc 函数防抖
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param immediate true 表立即执行，false 表非立即执行
 */
function debounce(func, wait = 1000, immediate = true) {
  let timeout;
  return function () {
    let context = this;
    let args = arguments;

    if (timeout) clearTimeout(timeout);
    if (immediate) {
      let callNow = !timeout;
      timeout = setTimeout(() => {
        timeout = null;
      }, wait)
      if (callNow) func.apply(context, args)
    }
    else {
      timeout = setTimeout(() => {
        func.apply(context, args)
      }, wait);
    }
  }
}
//不足位数前面补0
function PrefixInteger(num, length) {
	return (Array(length).join('0') + num).slice(-length)
}
export function time2date(micro_second) {
	var time = {}
	// 总秒数
	var second = Math.floor(micro_second)
	// 天数
	time.day = PrefixInteger(Math.floor(second / 3600 / 24), 2)
	// 小时
	time.hour = PrefixInteger(Math.floor((second / 3600) % 24), 2)
	// 分钟
	time.minute = PrefixInteger(Math.floor((second / 60) % 60), 2)
	// 秒
	time.second = PrefixInteger(Math.floor(second % 60), 2)

	var newtime = ''
//	if (time.day > 0) {
		newtime =
			time.day +
			'天' +
			time.hour +
			'小时' +
			time.minute +
			'分' +
			time.second +
			'秒'
//	} else {
//		if (time.hour != 0) {
//			newtime = time.hour + '小时' + time.minute + '分' + time.second + '秒'
//		} else {
//			newtime = time.minute + '分' + time.second + '秒'
//		}
//	}
	return newtime
}

//======================
//      图片缓存
//======================
export function image_cache(image_url,image_name,call_back) {
	// 本地没有缓存 需要下载 
	uni.downloadFile({
		url: image_url,
		success: (res) => {
			// #ifdef H5
				
				uni.setStorage({
					key:image_name,
					data:res.tempFilePath,
					success:function(){
						
					}
				})
				call_back(res.tempFilePath)
			// #endif
			// #ifdef APP-PLUS
			if (res.statusCode === 200) { 
				uni.saveFile({
					tempFilePath:res.tempFilePath,
					success:(res)=>{
						uni.setStorage({
							key:image_name,
							data:res.savedFilePath,
							success:function(){
								
							}
						})
						call_back(res.savedFilePath)
					},
					fail:()=>console.log('下载失败')
				})
				
			}
			// #endif
		}
	}); 
}
export default {
	checkPhone,
	debounce,
	getToken,
	setToken,
	time2date,
	addNum,
	changeNumMoneyToChinese,
	image_cache,
	chkMail
};
